export IconMenu from './IconMenu'

export default from './IconMenu'



// WEBPACK FOOTER //
// ./src/IconMenu/index.js